import styled from 'styled-components';

export const Container = styled.div`

    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f0f0f0;
    align-items: center;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    .tabs {
                display: flex;
                flex-direction: row;
                align-items:  center;
                margin-left: 32px;

                @media (max-width: 360px) {
                    margin-left: 16px;
                }

                .tab {
                    flex-direction: row;
                    align-items: center;
                    overflow-x: auto;
                    white-space: nowrap;
                    box-sizing: content-box;
                    scroll-behavior: smooth;
                    height: 28px;

                    ::-webkit-scrollbar {
                        display:none
                    }

                    button {
                        cursor: pointer;
                        background-color: transparent;
                        padding: 0;
                        margin-right: 64px;
                        outline: none;
                        border: none;
                        @media (max-width: 690px) {
                                margin-right: 32px;
                            }

                        .selected {
                            font-size: 16px;
                            margin: 0;
                            padding: 0;
                            color: #000000;
                            font-weight: 600;

                            @media (max-width: 360px) {
                                font-size: 12px;
                            }
                        }

                        .not-selected {
                            font-size: 16px;
                            margin: 0;
                            padding: 0;
                            color: #a49b9b;
                            font-weight: 600;

                            @media (max-width: 360px) {
                                font-size: 12px;
                            }
                        }
                    }
                }

                .icones {
                    display: flex;
                    flex-direction: row;
                    background-color: #fff;
                    padding-right: 24px;
                    -moz-box-shadow: 0 0 5px #fff;
                    -webkit-box-shadow: 0 0 5px #fff;
                    box-shadow: 0px 0px 5px #fff;

                    @media (max-width: 360px) {
                        padding-right: 8px;
                    }

                    button {
                        padding: 0;
                        margin-right: 16px;
                        background-color: transparent;
                        outline: none;
                        border: none;

                        .i {
                            cursor: pointer;
                            color: #000000
                        }

                        .i-close {
                            color: #a49b9b
                        }
                    }
                }
            }

    .div-pai {
        margin: 32px;
        background-color: #fff;
        max-width: 1096px;
        min-width: 300px;
        width: 88%;
        border-radius: 8px;

        @media (max-width: 1330px) {
            margin-bottom: 80px;
        }

        @media (max-width: 690px) {
            margin-top: 161px;
        }

        @media(max-width: 360px) {
            margin: 24px;
            margin-top: 153px;
            margin-bottom: 80px;
        }

        .div-rota {
            margin-right: 16px;
            margin-top: 40px;
            margin-left: 32px;
            width: 90%;
            overflow: hidden;
            white-space:nowrap;
            text-overflow: ellipsis;

            @media(max-width: 360px) {
                margin-left: 16px;
            }
            
            span {
                font-family: Montserrat;
                font-size: 14px;
                color: #2a0709;
                font-weight: 500;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }

            .rotas {
                font-family: Montserrat;
                font-size: 14px;
                color: #a49b9b;
                font-weight: normal;

                @media(max-width: 360px) {
                    font-size: 12px;
                }
            }
        }

        .turnos { 
            display: flex;
            flex-direction: column;
            margin-bottom: -39px;

            h2 {
                margin-top: 72px;
                margin-left: 32px;
                margin-right: 16px;
                margin-bottom: 56px;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 2;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                
                @media(max-width: 360px) {
                    font-size: 16px;
                    margin-top: 56px;
                    margin-bottom: 40px;
                    margin-left: 16px;
                }
            }

            input {
                width: 16px;
                height: 16px;
                margin-right: 16px;
            }

            .normal {
                cursor: pointer;
                align-items: center;
                margin-bottom: 33px;
                margin-left: 23px;

                .texto {
                    margin-bottom: 1px;
                    margin-left: 7px;
                    vertical-align: middle;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    letter-spacing: normal;
                    font-family: Montserrat;
                    color: #000000;
                }

                @media(max-width: 360px) {
                    margin-left: 7px;
                    margin-bottom: 24px;
                }
            }

            .selected {
                cursor: pointer;
                align-items: center;
                margin-bottom: 33px;
                margin-left: 23px;

                .texto {
                    margin-bottom: 1px;
                    margin-left: 7px;
                    vertical-align: middle;
                    font-size: 14px;
                    font-weight: 600;
                    font-stretch: normal;
                    font-style: normal;
                    letter-spacing: normal;
                    font-family: Montserrat;
                    color: #000000;
                }

                @media(max-width: 360px) {
                    margin-left: 7px;
                    margin-bottom: 24px;
                }
            }
        }

        .dias-fechados {
            display: flex;
            flex-direction: column;

            .botao {
                display: flex;
                width: 100%;
                padding-left: 32px;
                margin-bottom: 72px;

                @media(max-width: 360px) {
                        padding-left: 16px;
                        margin-bottom: 56px;
                    }

                .salvar {
                    cursor: pointer;
                    height: 40px;
                    width: 160px;
                    background-color: #fff;
                    outline: none;
                    border: 1px solid #c32027;
                    border-radius: 20px;
                    justify-content: center;
                    align-items: center;
                    color: #c32027;
                    font-family: Montserrat;
                    font-size: 11px;
                    font-weight: 600;
                    transition: 0.2s;

                    :hover {
                        background-color: #faf8f8
                    }

                    :active {
                        background-color: #dedede
                    }

                    @media(max-width: 360px) {
                        width: 100%;
                        margin-right: 32px;
                    }
                }
            }

            h2 {
                margin-top: 72px;
                margin-left: 32px;
                margin-right: 16px;
                margin-bottom: 56px;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                
                @media(max-width: 360px) {
                    font-size: 16px;
                    margin-top: 56px;
                    margin-bottom: 56px;
                    margin-left: 16px;
                }
            }

            .div-dias-fechados {
                width: 100%;
                flex-wrap: wrap;
                display: flex;
                margin-bottom: 72px;
                padding-left: 8px;
                margin-top: 32px;
                flex: 0 0 20%;

                @media (max-width: 360px) {
                        padding-left: 16px;
                        width: 100%;
                        flex: 1
                    }

                    .dia-fechado {
                        position: relative;
                        margin-top: 24px;
                        display:flex;
                        align-items: center;
                        justify-content: flex-start;
                        width: 252px;
                        height: 88px;
                        border: 1.5px solid #ececec;
                        background-color: #fff;
                        border-radius: 10px;
                        margin-left: 24px;

                        @media (max-width: 360px) {
                            align-self: center;
                            width: 89%;
                            margin-left: 0;
                        }

                        button {
                            cursor: pointer;
                            position: absolute;
                            top: 6px;
                            right: 3px;
                            border: 0;
                            outline: 0;
                            background-color: transparent;
                                .i-close {
                                font-size: 20px
                            }
                        }

                        .left {
                            display: block;
                            padding-left: 24px;
                            width: 208px;
                            overflow: hidden;
                            white-space:nowrap;
                            text-overflow: ellipsis;
                        }

                        span {
                            margin: 0;
                            padding: 0;
                            font-family: Montserrat;
                            font-size: 16px;
                            font-weight: 600;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1;
                            letter-spacing: normal;
                            text-align: left;
                            color: #2a0709;
                        }
                        h5 {
                            margin: 0;
                            margin-bottom: 12px;
                            padding: 0;
                            font-family: Montserrat;
                            font-size: 12px;
                            font-weight: 500;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.5;
                            letter-spacing: normal;
                            text-align: left;
                            color: #a49a9b;
                        }
                    }
            }
        }

        .feriados {
            display: flex;
            flex-direction: column;

            .div-feriados {
                width: 100%;
                flex-wrap: wrap;
                display: flex;
                margin-bottom: 72px;
                padding-left: 8px;
                margin-top: 32px;
                flex: 0 0 20%;

                @media (max-width: 360px) {
                        padding-left: 16px;
                        width: 89%;
                        flex: 1
                    }

                .feriado {
                    display: flex;
                    flex-direction: column;
                    margin-left: 24px;
                    margin-top: 24px;

                    @media (max-width: 360px) {
                            align-self: center;
                            width: 100%;
                            margin-left: 0;
                        }

                    .aberto-fechado {
                        cursor: pointer;
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        h4 {
                            margin: 0;
                            margin-left: 16px;
                            padding: 0;
                            font-family: Montserrat;
                            font-size: 16px;
                            font-weight: 600;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1;
                            letter-spacing: normal;
                            text-align: left;
                            color: #2a0709
                        }
                    }
                }

                    .dia-fechado {
                        position: relative;
                        display:flex;
                        align-items: center;
                        justify-content: flex-start;
                        width: 270px;
                        height: 88px;
                        border: 1.5px solid #ececec;
                        background-color: #fff;
                        border-radius: 10px;
                        margin-bottom: 24px;

                        @media (max-width: 360px) {
                            align-self: center;
                            width: 100%;
                            margin-left: 0;
                        }

                        button {
                            cursor: pointer;
                            position: absolute;
                            top: 6px;
                            right: 3px;
                            border: 0;
                            outline: 0;
                            background-color: transparent;
                                .i-close {
                                font-size: 20px
                            }
                        }

                        .left {
                            display: block;
                            padding-left: 24px;
                            width: 208px;
                            overflow: hidden;
                            white-space:nowrap;
                            text-overflow: ellipsis;
                        }

                        span {
                            margin: 0;
                            padding: 0;
                            font-family: Montserrat;
                            font-size: 16px;
                            font-weight: 600;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1;
                            letter-spacing: normal;
                            text-align: left;
                            color: #2a0709;
                        }
                        h5 {
                            margin: 0;
                            margin-bottom: 12px;
                            padding: 0;
                            font-family: Montserrat;
                            font-size: 12px;
                            font-weight: 500;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1.5;
                            letter-spacing: normal;
                            text-align: left;
                            color: #a49a9b;
                        }
                    }
            }

            h2 {
                margin-top: 72px;
                margin-left: 32px;
                margin-right: 16px;
                margin-bottom: 56px;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                
                @media(max-width: 360px) {
                    font-size: 16px;
                    margin-top: 56px;
                    margin-bottom: 56px;
                    margin-left: 16px;
                }
            }
        }

        .horarios {
            width: 100%;
            flex-wrap: wrap;
            display: flex;
            margin-bottom: 72px;
            flex: 0 0 20%;

            @media (max-width: 360px) {
                    padding-left: 16px;
                    width: 100%;
                    flex: 1
                }
            .horario {
                margin-left: 32px;
                position: relative;
                display: flex; 
                flex-direction: column;
                list-style: none;
                

                @media (max-width: 360px) {
                    margin-left: 0;
                    margin-right: 32px;
                    width: 100%;
                }
                h4 {
                    margin: 0;
                    margin-top: 72px;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 16px;
                    font-weight: 700;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1;
                    letter-spacing: normal;
                    text-align: left;
                    color: #000000;

                    @media (max-width: 360px) {
                        margin-top: 56px;
                    }
                }

                .turno-aberto {
                    margin-top: 40px;
                    margin-bottom: 24px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    width: 204px;
                    height: 88px;
                    border: 1.5px solid #ececec;
                    background-color: #fff;
                    border-radius: 10px;

                    @media (max-width: 360px) {
                        width: 100%;
                        margin-left: 0;
                        width: 100%
                    }

                    .chevron {
                        padding-right: 24px;
                    }

                    .left {
                        padding-left: 24px;
                    }

                    h4 {
                        margin: 0;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #2a0709;
                    }
                    h5 {
                        margin: 0;
                        margin-bottom: 12px;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 12px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.5;
                        letter-spacing: normal;
                        text-align: left;
                        color: #a49a9b;
                    }
                }

                .turno-fechado {
                    margin-top: 40px;
                    margin-bottom: 24px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    width: 204px;
                    height: 88px;
                    border: 1.5px solid #ececec;
                    background-color: #faf8f8;
                    border-radius: 10px;

                    @media (max-width: 360px) {
                        width: 100%;
                        margin-left: 0;
                        width: 100%
                    }

                    .chevron {
                        padding-right: 24px;
                    }

                    .left {
                        padding-left: 24px;
                    }

                    h4 {
                        margin: 0;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #2a0709;
                    }
                    h5 {
                        margin: 0;
                        margin-bottom: 12px;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 12px;
                        font-weight: 500;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1.5;
                        letter-spacing: normal;
                        text-align: left;
                        color: #a49a9b;
                    }
                }

                .aberto-fechado {
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    h4 {
                        margin: 0;
                        margin-left: 16px;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #2a0709
                    }
                }
            }
        }

        

        .label-resto {
            position: absolute;
            font-family: Montserrat;
            margin-left: 16px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            color: #000000;

            @media(max-width: 360px) {
                font-size: 16px;
                margin-top: 4px;
            }

        }

        .label-app {
            position: absolute;
            font-family: Montserrat;
            margin-left: 16px;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            color: #000000;
            opacity: 0.5;

            @media(max-width: 360px) {
                font-size: 16px;
                margin-top: 4px;
            }
        }

        hr {
            display: block; 
            height: 1px;
            border: 0; 
            border-top: 2px solid #f3f3f3;
            margin: 1em 0; 
            padding: 0;
        }

        .linha {
            width: 95%;
            border-top: 2px solid #f3f3f3;
            margin: auto;
            margin-top: 16px;
            margin-bottom: 16px
        }

        .emoji {
            width: 32px;
            height: 32px;
            margin-top: 40px;
            margin-left: 32px;
            margin-bottom: 24px;
            object-fit: contain;

            @media(max-width: 360px) {
                    margin-left: 16px;
                    margin-top: 32px
                }
        }

        h1 {
            font-family: Montserrat;
            font-size: 32px;
            margin-top: 24px;
            margin-left: 32px;
            margin-right: 16px;
            margin-bottom: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.67;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
                    margin-left: 16px;
                    font-size: 24px;
                }
        }

        .descricao {
            margin-top: 24px;
            margin-left: 32px;
            margin-right: 16px;
            margin-bottom: 72px;            
            font-family: Montserrat;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            text-align: left;
            color: #a49b9b;

            @media(max-width: 360px) {
                margin-left: 16px;
                margin-bottom: 56px;
                width: 183px;
            }
        }

        h4 {
            margin-top: 64px;
            margin-bottom: 40px;
            margin-left: 32px;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
                margin-left: 16px;
                margin-top: 68px;
                margin-bottom: 36px;
            }
        }

        img {
            width: 22px;
            height: 16px;
            object-fit: contain;
            
            @media(max-width: 360px) {
                    width: 33px;
                    height: 24px;
                }
        }

        .cards {
            width: 100%;
            /* background-color: blue; */
            margin-top: -32px;
            margin-bottom: 72px;
            display: flex;
            flex-wrap: wrap;

            @media(max-width: 360px) {
                margin-bottom: 56px;
            }

            .cartao {
                display: flex; 
                position: relative;
                flex-direction: row;
                align-items:center;
                height: 16px;
                margin-top: 40px;
                margin-left: 32px;
                margin-right: 16px;
                list-style: none;
                flex: 0 0 28%;

                @media(max-width: 360px) {
                    margin-left: 16px;
                    margin-top: 48px;
                }

                .main { 
                    display: block; 
                    position: relative; 
                    cursor: pointer;
                    width: 230px;

                    @media (max-width: 360px) {
                        width: 280px;
                    }
                } 
          
                /* Hide the default checkbox */ 
                input[type=checkbox] { 
                    visibility: hidden; 
                    margin-right: 16px;
                } 
                
                /* Creating a custom checkbox 
                based on demand */ 
                .check { 
                    position: absolute; 
                    top: 0; 
                    left: 0;
                    height: 16px; 
                    width: 16px; 
                    border-radius: 3px;
                    background-color: #fff; 
                    border: 1px solid #a49a9b;

                    @media(max-width: 360px) {
                        top: 4px;
                    }
                } 

                .check-app { 
                    position: absolute; 
                    top: 0; 
                    left: 0;
                    height: 16px; 
                    width: 16px; 
                    border-radius: 3px;
                    background-color: #fff; 
                    border: 1px solid #a49a9b;

                    @media(max-width: 360px) {
                        top: 4px;
                    }
                } 
                
                /* Specify the background color to be 
                shown when hovering over checkbox */ 
                .main:hover input ~ .check { 
                    background-color: #ebedee; 
                } 
                
                /* Specify the background color to be 
                shown when checkbox is active */ 
                .main input:active ~ .check { 
                    background-color: #c42027; 
                    border: 1px solid #c42027
                } 
                
                /* Specify the background color to be 
                shown when checkbox is checked */ 
                .main input:checked ~ .check { 
                    background-color: #d7232c; 
                    border: 1px solid #d7232c
                } 

                .main input:checked ~ .check-app { 
                    background-color: #dedede; 
                } 
                
                /* Checkmark to be shown in checkbox */ 
                /* It is not be shown when not checked */ 
                .check:after { 
                    content: ""; 
                    position: absolute; 
                    display: none; 
                } 

                .check-app:after { 
                    content: ""; 
                    position: absolute; 
                    display: none; 
                } 
                
                /* Display checkmark when checked */ 
                .main input:checked ~ .check:after { 
                    display: block; 
                } 

                .main input:checked ~ .check-app:after { 
                    display: block; 
                } 
                
                /* Styling the checkmark using webkit */ 
                /* Rotated the rectangle by 45 degree and  
                showing only two border to make it look 
                like a tickmark */ 
                .main .check:after { 
                    left: 5px; 
                    bottom: 5px; 
                    width: 4px; 
                    height: 6px; 
                    border: solid white; 
                    border-radius: 1px;
                    border-width: 0 2px 2px 0; 
                    -webkit-transform: rotate(45deg); 
                    -ms-transform: rotate(45deg); 
                    transform: rotate(45deg); 
                } 

                .main .check-app:after { 
                    left: 5px; 
                    bottom: 5px; 
                    width: 4px; 
                    height: 6px; 
                    border: solid #a49a9b; 
                    border-radius: 1px;
                    border-width: 0 2px 2px 0; 
                    -webkit-transform: rotate(45deg); 
                    -ms-transform: rotate(45deg); 
                    transform: rotate(45deg); 
                } 
            }
        }

        .div-app {

            h2 {
                margin-top: 72px;
                margin-left: 32px;
                margin-right: 16px;
                margin-bottom: 64px;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                
                @media(max-width: 360px) {
                    font-size: 16px;
                    margin-top: 56px;
                    margin-bottom: 56px;
                    margin-left: 16px;
                }
            }

            .img-app-disabled {
                width: 22px;
                height: 16px;
                object-fit: contain;
                opacity: 0.5;

                @media(max-width: 360px) {
                    width: 33px;
                    height: 24px;
                }
            }

        }

        .div-entrega {
            h2 {
                margin-top: 72px;
                margin-left: 32px;
                margin-right: 16px;
                margin-bottom: 64px;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;

                @media(max-width: 360px) {
                    font-size: 16px;
                    margin-top: 56px;
                    margin-bottom: 56px;
                    margin-left: 16px;
                }
            }
        }

        .botao {
            display: flex;
            width: 100%;
            padding-left: 32px;
            margin-bottom: 72px;

            @media(max-width: 360px) {
                    padding-left: 16px;
                    margin-bottom: 56px;
                }

            .salvar {
                cursor: pointer;
                height: 40px;
                width: 160px;
                background-color: #c32027;
                outline: none;
                border: none;
                border-radius: 20px;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 600;
                transition: 0.2s;

                :hover {
                    background-color: #9c1a1f
                }

                :active {
                    background-color: #d7232c
                }

                @media(max-width: 360px) {
                    width: 100%;
                    margin-right: 32px;
                }
            }
        }
    }
`

export const Atencao = styled.div`
            display: flex;
            flex-direction: column;
            margin-left: 32px;
            width: 88%;

            @media(max-width: 691px) {
                margin-left: 0;
                width: 100%;
            }

            .box {
                border: 1.5px solid #ececec;
                border-radius: 100px;
                width: 185px;
                height: 64px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;

                @media (max-width: 691px) {
                    width: 86%;
                    align-self: center;
                }

                .left {
                    display: flex;
                    flex-direction: row;
                    //padding-left: 32px;
                    align-items: center;

                    .alerta {
                        width: 24px;
                        height: 24px;
                    }

                    h5 {
                        margin: 0;
                        margin-left: 16px;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #000000;
                    }
                }

                .chevron {
                    padding-right: 32px;
                    transition: 0.3s transform;
                    -webkit-transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                    transform: ${({ open }) => open ? 'rotateX(180deg)' : 'rotateX(0deg)'};
                }
            }

            .textos {
                max-width: 620px;
                margin-left: 32px;
                margin-right: 16px;
                margin-top: 32px;
                margin-bottom: 32px;
                transition: opacity 0.2s ease-in-out;
                -webkit-transition: opacity 0.2s ease-in-out;
                -moz-transition: opacity 0.2s ease-in-out;
                -ms-transition: opacity 0.2s ease-in-out;
                -o-transition: opacity 0.2s ease-in-out;

                ul {
                    margin: 0;
                    padding: 0;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 2.29;
                    letter-spacing: normal;
                    text-align: left;
                    color: #a49b9b
                }
            }
`